import { render } from "./RequestOtpView.vue?vue&type=template&id=2e0ef627&scoped=true"
import script from "./RequestOtpView.vue?vue&type=script&lang=js"
export * from "./RequestOtpView.vue?vue&type=script&lang=js"

import "./RequestOtpView.vue?vue&type=style&index=0&id=2e0ef627&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0ef627"]])

export default __exports__